<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication" role="doc-dedication">
<p class="linespace" id="ded"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para1"><a id="pg_5"><em>For Hays Davis</em></a></p><a id="pg_5">
<p class="dedication">Many years (and beers) ago, during one of those all-nighters in which we alternately solved the world’s problems and decided what music belonged on our mix tapes, you made an offhand comment that stuck in my head and led directly to the writing of this book. For two decades’ (and counting) worth of friendship, I dedicate this to you, pal.</p>
</a></section><a id="pg_5">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?8b2759c0